import React, { useMemo, useState } from 'react';
import ManagerInsuranceCompaniesBatchesTable from '../ManagerInsuranceCompaniesBatchesTable/ManagerInsuranceCompaniesBatchesTable';
import {
	InsuranceCompanyBatch,
	InvoiceBatch,
} from '../../../../Consts/InsuranceCompanyBatchesDefaultColumns.const';
import {
	InsuranceCompanyBatchesCreateColumns,
	InsuranceCompanyBatchesCreateTable,
} from '../../../../Consts/InsuranceCompanyBatchesCreateColumns.const';

interface Props {
	batches: InsuranceCompanyBatch[];
}

const ManagerInsuranceCompaniesBatchCreateTable = ({
	batches: initialBatches,
}: Props) => {
	const [batches, setBatches] = useState(initialBatches);

	const table: InsuranceCompanyBatchesCreateTable = useMemo(
		() => ({
			onDelete: (id: string) =>
				setBatches(prev => prev.filter(batch => batch.id !== id)),
			onInvoiceCreated: (batchId: string, invoiceBatch: InvoiceBatch) =>
				setBatches(prev =>
					prev.map(batch =>
						batch.id === batchId
							? {
									...batch,
									childInvoiceBatch: {
										id: invoiceBatch.id,
										dcid: invoiceBatch.dcid,
										batchStatus: invoiceBatch.batchStatus,
										file: invoiceBatch.file,
									},
							  }
							: batch,
					),
				),
		}),
		[],
	);

	return (
		<ManagerInsuranceCompaniesBatchesTable
			data={batches}
			columns={InsuranceCompanyBatchesCreateColumns}
			table={table}
		/>
	);
};

export default ManagerInsuranceCompaniesBatchCreateTable;
